const PUSH_ENABLED_KEY = 'zion-push-enabled'

export function isPushEnabledLocally(): boolean {
  return localStorage.getItem(PUSH_ENABLED_KEY) === '1'
}

export function setPushEnabledLocally(on: boolean): void {
  if (on) localStorage.setItem(PUSH_ENABLED_KEY, '1')
  else localStorage.removeItem(PUSH_ENABLED_KEY)
}

export function savePushSubscriptionJson(json: string): void {
  localStorage.setItem('zion-push-subscription', json)
}

export function loadPushSubscriptionJson(): string | null {
  return localStorage.getItem('zion-push-subscription')
}

export function loadPushSubscriptionEndpoint(): string {
  try {
    const raw = loadPushSubscriptionJson()
    if (!raw) return ''
    const parsed = JSON.parse(raw) as { endpoint?: string }
    return String(parsed?.endpoint || '').trim()
  } catch {
    return ''
  }
}

/** Flag: server ha segnalato subscription scaduta (410/404) → forza resubscribe. */
export function markPushNeedsResubscribe(): void {
  localStorage.setItem('zion-push-needs-resubscribe', '1')
}

export function consumePushNeedsResubscribe(): boolean {
  const on = localStorage.getItem('zion-push-needs-resubscribe') === '1'
  if (on) localStorage.removeItem('zion-push-needs-resubscribe')
  return on
}

export function clearPushSubscriptionLocal(): void {
  localStorage.removeItem('zion-push-subscription')
  localStorage.removeItem(PUSH_ENABLED_KEY)
  localStorage.removeItem('zion-push-needs-resubscribe')
}
